package ru.malygin.helpers

import kotlin.math.round

fun Double.roundMy(
    x: Int = 4
): Double {
    val roundXX = ("1"+"0".repeat(x)).toInt()

    return round(
        this * roundXX
    ) / roundXX
}

fun Double.moreAndLessThem(
    max: Double,
    min: Double
): Double{
    return when{
        this > max -> {max}
        this < min -> {min}
        else -> {this}
    }
}